import { IDownloadControlePatrimonioArquivoUseCase } from "../../../presentation/useCases/read/download_controle_patrimonio_arquivo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class DownloadControlePatrimonioArquivoUseCase implements IDownloadControlePatrimonioArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async downloadControlePatrimonioArquivo(
    idMaquinaEquipArquivo: number,
    imageName: string,
  ): Promise<void> {
    const blob = await this.repository.downloadControlePatrimonioArquivo(
      idMaquinaEquipArquivo,
    );

    if (!blob) throw new Error("Falha ao buscar dados da imagem!");

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", String(imageName));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
